module.exports = __webpack_public_path__ + "img/success.bc7d14ca.svg";